import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const DiscountsIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.9998 16.7732C32.9871 25.6064 25.8395 32.7668 17.0062 32.7668C8.17303 32.7668 1 25.5938 1 16.7605C1 7.92722 8.16036 0.75415 17.0062 0.75415C19.4648 0.75415 21.784 1.31177 23.8624 2.30029C23.4189 3.46623 23.1908 4.72088 23.1908 6.02623C23.1908 6.27969 23.2034 6.53316 23.2161 6.78663C23.4696 10.4999 25.6113 13.6936 28.6783 15.4171C29.9709 16.1522 31.441 16.6338 32.9998 16.7732Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.0005 16.762C31.4417 16.6352 29.9716 16.1536 28.6789 15.4186C25.612 13.695 23.4702 10.5014 23.2168 6.78809C23.2041 6.53463 23.1914 6.28116 23.1914 6.0277C23.1914 4.72235 23.4195 3.4677 23.8631 2.30176L33.0005 16.762Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7549 16.7591C28.7549 23.2478 23.4955 28.5072 17.0068 28.5072C10.5181 28.5072 5.24609 23.2478 5.24609 16.7591C5.24609 10.2704 10.5181 5.01099 17.0068 5.01099C19.288 5.01099 21.4171 5.65732 23.2167 6.78524C23.4702 10.4985 25.6119 13.6922 28.6788 15.4157C28.7295 15.8593 28.7549 16.3029 28.7549 16.7591Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0539 15.3791C14.9218 15.3791 15.6254 14.6755 15.6254 13.8076C15.6254 12.9397 14.9218 12.2361 14.0539 12.2361C13.186 12.2361 12.4824 12.9397 12.4824 13.8076C12.4824 14.6755 13.186 15.3791 14.0539 15.3791Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1496 21.3988C21.0175 21.3988 21.7211 20.6953 21.7211 19.8273C21.7211 18.9594 21.0175 18.2559 20.1496 18.2559C19.2817 18.2559 18.5781 18.9594 18.5781 19.8273C18.5781 20.6953 19.2817 21.3988 20.1496 21.3988Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7061 13.0854L13.457 20.3472"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DiscountsIcon;
